export interface CreditCostsClassNames {
  container: string;
  wrapper: string;
  item: string;
  heading: string;
  pounds: string;
  cents: string;
  value: string;
  separator: string;
}

export const CLASS_NAMES: CreditCostsClassNames = {
  container: 'w-full flex flex-col md:flex-row bg-purple-50 rounded p-6',
  wrapper: 'grid grid-cols-2 gap-x-10 gap-y-4 w-full',
  item: 'flex flex-col h-10',
  heading: 'text-10-17-em-up text-neutral-600 mb-1 whitespace-nowrap',
  pounds: 'text-16-20 text-neutral-800',
  cents: 'text-10-14 text-neutral-800',
  value: 'text-16-20 text-neutral-800',
  separator: 'my-6 md:my-0 md:mx-8 border-t md:border-r border-purple-200',
};
